<template>
    <div class="con" :class="{'dark':active2}">
        <div class="con1">
            <div class="main">
                <img class="a" src="../assets/yr/logo.svg" alt="" @click="goto(0)">
                
                <div class="navList">
                    <ul>
                        <li  v-for="(item,index) in $t('list')" :key="index" @mouseenter="showList(index)" @click="goto(index)" :class="{'showStyle':select===index}">
                            {{item}}
                            <div class="pList"  v-if="index===2"  :class="{'hideP':isSe===false}">
                                <div class="m11">
                                    <div class="item" v-for="(item,index) in proList" :key="index" @click.stop="gotoPro(item.ID,item.CALLED,item.ISNEED)">
                                        <div class="o1">
                                            <img :src="`http://www.yourlonglighting.com/upload/${item.PICURL}`" alt="">
                                        </div>
                                        <p>{{item.CALLED}}</p>
                                    </div>
                                </div>

                            </div>
                        </li>
                    </ul>
                </div>
                <div class="icon">
                    <i class="iconfont icon-sousuo" @click="searchShow=!searchShow"></i>
                    <i class="iconfont icon-diqiu" @click="showLan=!showLan"></i>
                    <div class="yy animated fadeIn  " v-if="showLan">
                        <p @click="changeLan('zh-CN')">CN</p>
                        <p @click="changeLan('en')">EN</p>
                    </div>
                </div>
            </div>

        </div>
        <div class="top animated fadeInUp">
            <img class="a" src="../assets/yr/logo.png" alt="" @click="goto(0)">
            <div class="mNav" :class="{active: menuOpen}" @click="menuOpen=!menuOpen">
                <span class="burger"></span>
                <span class="burger"></span>
                <span class="burger"></span>
            </div>
        </div>
        <div class="menuBox" :class="{open: menuOpen}">
            <div class="item">
                <span v-for="(item,index) in $t('list')" :key="index" @click="goto(index)">{{item}}</span>
            </div>
            <div class="language">
                <p @click="changeLan('zh-CN')">CN</p>
                <p @click="changeLan('en')">EN</p>
            </div>
        </div>
            <div class="sea" :class="{'animated fadeInLeft':searchShow===true,'animated fadeOutRight':searchShow===false,'noShow':searchShow===0}">
                <div style="position: absolute;height:100%;width:100%;z-index: -1;top:0;left: 0;" @click="searchShow=false;input=''">
                </div>
                <div class="ma">
                    <input style="z-index: 1;" type="text" v-model="input" placeholder="请输入要搜索的关键字"  @keyup.enter="gotoSearch">
                    <i class="iconfont icon-sousuo"  @click="gotoSearch"></i>
                </div>

            </div>


        <el-dialog title="User Info" :visible.sync="dialogFormVisible" style="margin-top:5%;">
            <el-form :mode="form">
                <el-form-item label="PassWord">
                    <el-input v-model="form.password" type="password" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="confirm">Confirm</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Scrollbar from 'smooth-scrollbar';
    import {getProductstypeUrl2} from '../util/lang'
    import { setup } from "../local/index"
    export default {
        name: "first",
        data(){
            return{
                dialogFormVisible:false,
                form:{
                    password:''
                },
                menuOpen:false,
                bStyle:{},
                isSe:0,
                searchShow:0,
                input:'',
                select:'',
                proList2:[],
                aStyle:{},
                active2:false,
                scrollbar:'',
                top:'',
                id:'',
                text:'',
                showLan:false,
                list:[
                    "HOME",
                    "ABOUT",
                    "PRODUCT",
                    "QUALIFICATION",
                    "NEWS",
                    "CONTACT"
                ],
                proList:[]
            }
        },
        watch: {
            $route: 'getScrollbar'
        },
        mounted(){
            this.$nextTick(()=>{
                this.getScrollbar()
                if(this.$i18n.locale==='en'){
                    this.getPro('72')
                }else{
                    this.getPro('84')
                }
            })
        },
        methods:{
            confirm(){
                if(this.form.password!=='66668888'){
                    this.$notify({
                        title: 'Sorry',
                        message: 'Please enter the complete information',
                        offset: 100
                    });
                }else {
                    this.form={
                        password:''
                    }
                    this.dialogFormVisible=false
                    this.$notify({
                        title: 'Correct',
                        message: 'Coming to the next page',
                        offset: 100
                    });
                    setTimeout(()=>{
                        this.$router.push({path:'/proList',query:{id:this.id,text:this.text}})
                        this.$router.go(0)
                    },100)
                }
            },
            // showPlist(){
            //     // this.isSe=true
            // },
            // hidePlist(){
            //     this.isSe=false
            //     setTimeout(()=>{
            //         this.isSe=0
            //     },1000)
            // },
            changeLan(n){
                this.$i18n.locale = n
                window.localStorage.setItem('language', n)
                setup(n);
                this.$router.go(0)
            },
            getPro(id){
                this.$nextTick(()=>{
                    const url = `${getProductstypeUrl2(this.$i18n.locale,id)}`
                    this.$axios.get(url).then(res => {
                        this.proList=res.data
                        console.log(this.proList)
                    })
                })
            },
            gotoPro(id,t,isneed){
                if(isneed==='1')
                {
                    this.id=id
                    this.text=t
                    this.form={
                        password:''
                    }
                    this.dialogFormVisible=true
                }else{
                    this.$router.push({path:'/proList',query:{id:id,text:t}})
                    this.$router.go(0)
                }

                // if(this.isSe===true){
                //     this.$router.push({path:'/pro',query:{index:n,id:id}})
                // }else{
                //     this.$router.push({path:'/tele',query:{index:n,id:id}})
                // }
                // this.hide()
            },
            gotoSearch(){
                this.searchShow=false
                this.$router.push({path:'/proSearch',query:{value:this.input}})
                this.input=''
                // this.$router.go(0)
            },
            hide(){
                this.aStyle={width:'0'}
             setTimeout(()=>{
                 this.bStyle={width:'0'}
                 this.proList2=[]
             },1000)
            },
            showList(n){
               if(n===2){
                   setTimeout(()=>{
                       this.isSe=true
                   },100)
               }else{
                   this.isSe=false
                   setTimeout(()=>{
                       this.isSe=0
                   },100)
               }
            },
            goto(n){
                this.menuOpen=false
              this.hide()
                localStorage.setItem('index',n)
             if(n===3){
              this.$router.push({path:'/honor'})
             }else if(n===0){
                 this.$router.push({path:'/'})
             }else if(n===2){
                 this.$router.push({path:'/pro'})
             }else if(n===4){
                 this.$router.push({path:'/news'})
             }else if( n===1){
                 this.$router.push({path:'/about'})
             }else if(n===5){
                 this.$router.push({path:'/support'})
             }
            },
            scrollHeader(scrollTop){
                this.active2=scrollTop>200 ? true : false
            },
            getScrollbar(){
                this.$nextTick(()=>{
                    this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
                    this.active2=false
                    this.select=parseInt(localStorage.getItem('index'))
                    let scrollHeader=this.scrollHeader
                    if(this.scrollbar){
                        this.scrollbar.addListener((status) => {
                            scrollHeader(status.offset.y)
                        });
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    position: fixed;
    top:0;
    left:0;
    z-index: 1000;
    transition: all 600ms;
    .sea{
        position: fixed;
        left: 0;
        height:80px;
        width:100%;
        top:0;
        text-align: center;
        padding-top: 30px;
        .ma{
           width:300px;
            margin: 0 auto;
            input{
                width:300px;
                height:30px;
                border-radius: 20px;
                border: none;
                border-bottom: 1px solid white;
                text-indent: 30px;
            }
            input:focus{
                outline: none;
            }
            i{
                margin-left: -40px;
            }
            .icon-sousuo::before{
                font-size:20px;
                cursor: pointer;
                color:black;
            }
        }
    }
    .noShow{
            display: none;
        }
    .con1{
        width:100%;
        background-color: #FFFFFF;
        padding-bottom: 20px;
        position: relative;
        .main{
            width:80%;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            .a{
                height:74px;
                width:183px;
                margin-top: 20px;
                cursor: pointer;
                object-fit: contain;
                transition: all 600ms;
            }
            .a{
                display: block;
                transition: all 600ms;
            }
            .navList{
                width:80%;
                margin-left: 8%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                height:30px;
                margin-top: 50px;
                transition: all 600ms;
                ul{
                    width:100%;
                    display: flex;
                    flex-direction: row;
                    height:30px;
                    margin-block-start: 0;
                    margin-block-end: 0;
                    list-style: none;
                    justify-content: space-between;
                    color:black;
                    font-family: Calibri;
                    text-transform: uppercase;
                    li{
                        display: inline-block;
                        text-align: center;
                        text-transform: uppercase;
                        line-height: 30px;
                        height:30px;
                        transition: all 600ms;
                        cursor: pointer;
                        padding: 3px 20px;
                        border-radius: 20px;
                        .pList{
                            position: absolute;
                            left:0;
                            top:-600px;
                            background-color: white;
                            z-index: 1000;
                            width:100%;
                            transition: all 600ms;
                            .m11{
                                display: flex;
                                flex-direction: row;
                                flex-wrap: wrap;
                                width:1280px;
                                margin: 40px auto;
                                justify-content: center;
                                .item{
                                    width:12%;
                                    margin-left: 2%;
                                    cursor: pointer;
                                    .o1{
                                        width:100%;
                                        overflow: hidden;
                                        padding: 10px 0;
                                        /*border: 1px solid rgba(0,0,0,.5);*/
                                        text-align: center;
                                        transition: all 1s;
                                        img{
                                            width:90%;
                                            object-fit: contain;
                                            height:120px;
                                        }
                                    }
                                    p{
                                        font-size: 14px;
                                        text-align: center;
                                        transition: all 1s;
                                    }
                                }
                                .item:hover{
                                    .o1{
                                        transform: translateY(-10px);
                                    }
                                    p{
                                        transform: translateY(-10px);
                                    }
                                }
                            }
                        }
                        .hideP{
                            display: none;
                        }
                    }
                    li:hover{
                        color:white;
                        background-color: #F4A000;
                        .pList{
                            top:88px;
                            .m11{
                                .item{
                                    p{
                                        color:black;
                                    }
                                }
                            }
                        }
                    }
                    .showStyle{
                        color:white;
                        background-color: #F4A000;
                    }
                }
            }
            .icon{
                display: flex;
                flex-direction: row;
                color:#767676;
                margin-left: 5%;
                width:5%;
                justify-content: space-between;
                padding-top:50px;
                transition: all 600ms;
                i{
                    transition: all 2s;
                }
                i:hover{
                    color:#F4A000;
                }
                .yy{
                    width:120px;
                    background-color: white;
                    position: absolute;
                    right:7.5%;
                    top:80px;
                    text-align: center;
                    border-radius:10px;
                    box-shadow: 2px 2px 2px 2px #e2e2e2;
                    p{
                        color:black;
                        cursor: pointer;
                        margin: 0;
                        padding: 8px 0;
                        font-size: 14px;
                        cursor: pointer;
                        transition: all 2s;
                    }
                    p:hover{
                        color:#F4A000;
                    }
                }
            }
        }

    }
    .list{
        width:0;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        display: flex;
        transition: all 1s;
        background-color: rgba(0,0,0,.8);
        overflow: hidden;
        .wclosebtn {
            cursor: pointer;
            width:100%;
            text-align: center;
            margin-top: 30px;
            padding-bottom: 10px;
            span{
                vertical-align: middle;
            }
            .icon{
                position: relative;
                width: 35px;
                height: 35px;
                margin-left: 12px;
                display: inline-block;
                .circle{
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: block;
                    width: 100%;
                    height: 100%;
                    box-sizing: border-box;
                    border: 2px solid white;
                    border-radius: 50%;
                    -webkit-transition: all 300ms ease-out;
                    transition: all 300ms ease-out;
                    -webkit-transform-origin: center center;
                    -ms-transform-origin: center center;
                    transform-origin: center center;
                }
                .line1,.line2{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    display: block;
                    width: 14px;
                    height: 2px;
                    margin: -1px 0 0 -7px;
                    background-color: white;
                    -webkit-transition: all 300ms ease-out;
                    transition: all 300ms ease-out;
                }
            }
            .icon:hover .circle{
                transform: scale(1.1);
            }
            .icon:hover .line1{
                transform: rotate(45deg);
            }
            .icon:hover .line2{
                -webkit-transform: rotate(-45deg);
                -ms-transform: rotate(-45deg);
                transform: rotate(-45deg);
                top: 16px;
            }
        }
        .item{
            width:30%;
            color:white;
            text-transform: uppercase;
            text-align: center;
            cursor: pointer;
            margin-top: 30px;
            div{
                height:200px;
                img{
                    transition: all 2s;
                }
            }
            p{
                transition: all 2s;
                color:white;
            }
        }
        .item a:hover{
           p{
               color:#C7000C;
           }
            img{
                transform: scale(1.05);
            }
        }
    }
    .top{
        display: none;
    }
    .menuBox{
        position: fixed;
        top: 89px;
        left:-100%;
        height:100vh;
        width: 100%;
        background:  #F4A000;
        z-index: 1010;
        transition: .8s;
        display: block;
        padding-top: 60px;
    }
    .menuBox .language{
        width:100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        p{
            color:white;
            text-align: center;
            width:80%;
            display: block;
            margin-left: 20%;
        }
    }
    .menuBox.open{
       left:-25%;
    }
    .menuBox .item span{
        display: block;
        font-size: 18px;
        color:white;
        width:80%;
        margin-left: 20%;
        padding: 18px 0px;
        text-align: center;
        text-transform: uppercase;
    }
    @media screen and (max-width:1366px){
 .list{
     .item{
         div{
             height:180px;
         }
     }
 }
        .con1{
            .main{
                .navList{
                    margin-left: 0;
                }
            }
        }
    }
    @media screen and (max-width:450px){
        background-color: #F4A000;
        .con1{
            display: none;
        }
        .top{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width:100%;
            padding: 20px 0px;
            transition: all 2s;
        }
        .a{
            height:50px;
            object-fit: cover;
            margin-left: 30%;
            display: block;
            transition: all 600ms;
        }
        .mNav{
            display: block;
            transition: .8s;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            width: 60px;
        }
        .mNav .burger{
            width: 32px;
            height: 4px;
            background-color: white;
            position: absolute;
            top: 28px;
            left: 50%;
            margin: 0px 0px 0px -16px;
            transform-origin: center;
            transition: .8s;
        }
        .mNav .burger:nth-of-type(2){
            top: 38px;
        }
        .mNav .burger:nth-of-type(3){
            top: 48px;
        }
        .mNav.active{
            background-color: #F4A000;
        }
        .mNav.active .burger{
            background-color: #fff;
        }
        .mNav.active .burger:nth-of-type(1){
            top: 40px;
            transform: rotate(225deg);
        }
        .mNav.active .burger:nth-of-type(2){
            left: -100%;
            opacity: 0;
        }
        .mNav.active .burger:nth-of-type(3){
            top: 40px;
            transform: rotate(-225deg);
        }
    }
}
    .dark{
        .con1{
            .main{
                .a{
                    height:50px;
                    width:160px;
                    object-fit: contain;
                }
                .navList{
                    margin-top: 40px;
                    ul{
                        li::before{
                            top:142%;
                        }
                        li:hover{
                            .pList{
                                top:77px;
                            }
                        }
                    }
                }
                .icon{
                    padding-top:40px;
                }
            }
        }
    }
</style>
